export default __webpack_public_path__ + "static/media/placeholder_dummy2016-delikatessen01.41273707.png";